import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=4b6c4d84&scoped=true"
import script from "./FileSelector.vue?vue&type=script&lang=js"
export * from "./FileSelector.vue?vue&type=script&lang=js"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=4b6c4d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c4d84",
  null
  
)

export default component.exports